import React, { useState, useEffect } from 'react';
import { fetchAPI } from '../../utils/api';

export default function RecentActivity({ currentUser }) {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadActivities = async () => {
            if (!currentUser) return;
            try {
                const data = await fetchAPI(`/student/get_recent_activity.php?user_id=${currentUser.id}`);
                setActivities(data);
            } catch (err) {
                console.error("Failed to load activities", err);
            } finally {
                setLoading(false);
            }
        };
        loadActivities();
    }, [currentUser]);

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-blue-50/50 p-6 h-full relative overflow-hidden">

            <div className="flex items-center gap-3 mb-8">
                <div className="w-1 h-6 bg-blue-600 rounded-full"></div>
                <h2 className="text-lg font-bold text-gray-900">Activity Log</h2>
            </div>

            <div className="space-y-0 pl-2">
                {loading ? (
                    <p className="text-sm text-gray-400 italic">Loading activity...</p>
                ) : activities.length === 0 ? (
                    <p className="text-sm text-gray-400 italic">No recent activity</p>
                ) : activities.map((log, idx) => (
                    <div key={log.id} className="relative pl-8 pb-8 last:pb-0">
                        {/* Timeline Line */}
                        {idx !== activities.length - 1 && (
                            <div className="absolute left-[9px] top-2 bottom-0 w-0.5 bg-gray-100"></div>
                        )}

                        {/* Dot */}
                        <div className={`absolute left-0 top-1.5 w-5 h-5 rounded-full border-4 border-white shadow-sm flex items-center justify-center ${log.action.includes('LOGIN') ? 'bg-blue-500' :
                                log.action.includes('PAYMENT') ? 'bg-emerald-500' : 'bg-indigo-500'
                            }`}>
                        </div>

                        <div className="flex flex-col -mt-1">
                            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest leading-none mb-1">
                                {new Date(log.created_at).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            </span>
                            <span className="text-gray-900 font-bold text-sm">{log.action.replace(/_/g, ' ')}</span>
                            <span className="text-gray-500 text-xs mt-0.5 leading-relaxed">{log.details}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
